// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2RpLo","title":"AfterFrontImage_title__2-Xt5"};